import { useFormContext } from "react-hook-form";

import { FormValues } from "../new-employee-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form/form";
import { HelperButton } from "@/components/ui/helper-button/helper-button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select/select";
import { Input } from "@/components/ui/input/input";
import { Textarea } from "@/components/ui/textarea/textarea";

interface NewEmployeePersonalProps {
  isPending: boolean;
}

// ? TAB Personal
// ! bloodGroup: string,
// ? TAB Personal

export const NewEmployeePersonal = ({
  isPending,
}: NewEmployeePersonalProps) => {
  const form = useFormContext<FormValues>();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
      <FormField
        control={form.control}
        name="bloodGroup"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Blood Group
              <HelperButton>
                <p>Blood group of the employee</p>
              </HelperButton>
            </FormLabel>
            <Select
              onValueChange={field.onChange}
              defaultValue={field.value}
              disabled={isPending}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select blood group" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="A+">A+</SelectItem>
                <SelectItem value="A-">A-</SelectItem>
                <SelectItem value="B+">B+</SelectItem>
                <SelectItem value="B-">B-</SelectItem>
                <SelectItem value="AB+">AB+</SelectItem>
                <SelectItem value="AB-">AB-</SelectItem>
                <SelectItem value="O+">O+</SelectItem>
                <SelectItem value="O-">O-</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="panNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              PAN Number
              <HelperButton>
                <p>PAN of the Employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="text" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="employeeCode"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Employee Code
              <HelperButton>
                <p>Code of the Employee</p>
              </HelperButton>
            </FormLabel>
            <FormControl>
              <Input type="text" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="pfNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">PF Number</FormLabel>
            <FormControl>
              <Input type="text" {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="familyDetails"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Family Details
            </FormLabel>
            <FormControl>
              <Textarea rows={5} {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="otherDetails"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="flex items-center gap-1">
              Other Details
            </FormLabel>
            <FormControl>
              <Textarea rows={5} {...field} disabled={isPending} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
